import React from "react";
import "./Tile.css";

interface Props {
  image?: string;
  number: number;
  highlight: boolean;
}

const Tile = ({ number, image, highlight }: Props) => {
  const className: string = [
    "tile",
    number % 2 === 0 && "dark_tile",
    number % 2 !== 0 && "light_tile",
    highlight && "tile-highlight",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={className}>
      {image && (
        <div
          style={{ backgroundImage: `url(${image})` }}
          className="chess_piece"
        ></div>
      )}
    </div>
  );
};
export default Tile;
